// extracted by mini-css-extract-plugin
export default {"button":"style_button__HRfp0","primary":"style_primary__Zr+mr","accent":"style_accent__a8sAM","outlined":"style_outlined__lyX7n","none":"style_none__1peLu"};